export default __webpack_public_path__ + "static/media/right.2086833f.svg";